import { FieldPath, FieldValues, UseControllerProps, useController } from 'react-hook-form';
import { WysiwygContentEditor, WysiwygContentEditorProps } from 'components/wysiwyg/Wysiwyg';

interface UseFormEditorProps<T extends FieldValues, K extends FieldPath<T>>
    extends UseControllerProps<T, K>,
        WysiwygContentEditorProps {}

const UseFormWysiwyg = <T extends FieldValues, K extends FieldPath<T>>(
    props: UseFormEditorProps<T, K>,
) => {
    const { control, name, rules, defaultValue, ...restEditorProps } = props;
    const {
        field: { value, onChange },
    } = useController({
        name,
        control,
        rules,
    });

    return (
        <WysiwygContentEditor
            initialValue={defaultValue}
            value={value}
            onEditorChange={value => onChange(value)}
            {...restEditorProps}
        />
    );
};

export { UseFormWysiwyg };
